<template>
  <div class="weui_dialog_alert" @touchmove="!this.scroll && $event.preventDefault()">
    <div class="weui_mask"  v-show="show" :transition="maskTransition" @click="onHide"></div>
    <div class="weui_dialog" v-show="show" :transition="dialogTransition">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    hideOnBlur: Boolean,
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    onHide () {
      this.show = false
      this.$emit('on-hide')
    }
  },
  watch: {
    show (val) {
      this.$emit(val ? 'on-show' : 'on-hide')
      this.$emit('input', val)
    },
    value (val) {
      this.show = val
    }
  }
}
</script>

<style lang="less">
@import '../../styles/transition.less';
@import '../../styles/cui/widget/cui_tips/cui_mask';
@import '../../styles/cui/widget/cui_tips/cui_dialog';
</style>



// WEBPACK FOOTER //
// x-dialog.vue?5cde88c5